import React, {useState} from 'react';
import OtherPages from '../../Components/OtherPages/OtherPages';
import './Sustainability.scss';
import socialImg from '../../Assets/social.jpg'
import healthImg from '../../Assets/health.jpg'
import susImg from '../../Assets/sustainability.jpg'

function Sustainability() {
    const [activeTab, setActiveTab] = useState("social");
  return (
    <div>
        <OtherPages
            pageName="Sustainability"
        />
        <div className='SustainabilityContainer'>
            {/* session for training tabs here */}
            <div className='container'>
                <div className="tabsContainer">
                    <div className="tabsHeader">
                        <button
                            className={activeTab === "social" ? "tabButton active" : "tabButton"}
                            onClick={() => setActiveTab("social")}
                        >
                            Social Impact
                        </button>
                        <button
                            className={activeTab === "health" ? "tabButton active" : "tabButton"}
                            onClick={() => setActiveTab("health")}
                        >
                            Health & Safety
                        </button>
                        <button
                            className={activeTab === "sustainability" ? "tabButton active" : "tabButton"}
                            onClick={() => setActiveTab("sustainability")}
                        >
                            Sustainability
                        </button>
                    </div>

                    <div className="tabContent">
                        {activeTab === "social" && (
                            <div>
                                <div className="sub-heading">Alchemie Marine Services (AMS) Social Impact</div>
                                <div className='row g-4'>
                                    <div className="col-lg-6 col-md-12">
                                        <div className='page-text' style={{paddingTop: '40px'}}>
                                            At Alchemie Marine, we believe that true progress extends beyond offshore operations. Our commitment to social impact drives us to invest in the communities where we operate. Through local employment, capacity building, and partnerships with community stakeholders, we support 
                                            economic growth and create opportunities for young professionals.
                                        </div>

                                        <div className='page-text'>
                                            We also contribute to social development programs, promote responsible engagement, and uphold ethical practices that strengthen trust and long-term collaboration with coastal and host communities.
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="tabImage">
                                            <img src={socialImg} alt="social" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === "health" && (
                            <div>
                                <div className="sub-heading">Safety First</div>
                                <div className='row g-4'>
                                    <div className="col-lg-6 col-md-12">
                                        <div className='page-text' style={{paddingTop: '40px'}}>
                                            Safety is the foundation of everything we do. Alchemie Marine is dedicated to maintaining the highest standards of Health, Safety, and Environment (HSE) across all operations.
                                        </div>
                                        <div className='page-text'>
                                            We implement strict safety protocols, continuous crew training, risk assessments, and industry-compliant procedures to ensure a safe working environment for our personnel, clients, and partners.
                                        </div>
                                        <div className='page-text'>
                                            Our “Zero Harm” approach reflects our unwavering focus on preventing incidents, safeguarding lives, and delivering operations that meet global marine safety benchmarks.
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                        <div className="tabImage">
                                            <img src={healthImg} alt="social" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === "sustainability" && (
                            <div>
                                <div className="sub-heading">Sustainability</div>
                                <div className='row g-4'>
                                    <div className="col-lg-6 col-md-12">
                                        <div className='page-text' style={{paddingTop: '40px'}}>
                                            Alchemie Marine is committed to responsible marine operations that protect the environment and support long-term ecological balance.
                                        </div>
                                        <div className='page-text'>
                                            We promote sustainable practices through efficient resource management, reduced emissions, environmentally conscious vessel operations, and adherence to all maritime environmental regulations.
                                        </div>
                                        <div className='page-text'>
                                            By adopting innovative technologies and promoting environmental stewardship, we ensure our services contribute to preserving marine ecosystems for future generations while providing reliable offshore support today.
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                        <div className="tabImage">
                                            <img src={susImg} alt="social" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Sustainability